module.exports = __webpack_public_path__ + "static/media/filtericon.c06bb179.png";